import {useLocalStorage} from 'utilities/hooks/useLocalStorage';
import useSetBookmark from 'utilities/hooks/bookmark/useSetBookmark';
import Item from './item';
import EmptyPost from 'assets/images/emptyPage/empty page.svg';
const ShownAds = ({app}: IShownAdsProps) => {
  const [bookmarks, setBookmarks] = useLocalStorage('bookmarks', []);
  const {handleBookMark} = useSetBookmark();
  const handleBokmarks = (post: IGetPostDetail) => {
    handleBookMark(bookmarks, post, setBookmarks);
  };
  return (
    <div className="flex flex-col mb-32">
      <div
        className=" flex justify-end ml-4 mt-6"
        onClick={() => setBookmarks([])}
      >
        <span className="icon-trash text-error mx-1 text-xl "></span>
        <p className=" text-gray-6">حذف همه</p>
      </div>
      {bookmarks.length === 0 ? (
        <div className=" mt-28">
          <img src={EmptyPost} alt="empty" className=" block mx-auto" />
          <p className=" text-gray-5 text-center">
            موردی برای نمایش وجود ندارد.
          </p>
        </div>
      ) : (
        bookmarks
          .reverse()
          .map(item => (
            <Item
              key={item.guid}
              app={app}
              type={item.type}
              post={item}
              handleBokmarks={handleBokmarks}
            />
          ))
      )}
    </div>
  );
};

export default ShownAds;
